/**
 * Card Component
 *
 * Container component for grouping related content.
 */

import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

export const Card: React.FC<CardProps> = ({ children, title, style }) => {
  const cardStyles: React.CSSProperties = {
    backgroundColor: 'var(--bg-card)',
    borderRadius: '12px',
    boxShadow: '0 1px 3px var(--shadow), 0 1px 2px var(--shadow)',
    padding: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid var(--border-light)',
    ...style,
  };

  const titleStyles: React.CSSProperties = {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '16px',
    color: 'var(--text-primary)',
  };

  return (
    <div style={cardStyles}>
      {title && <h2 style={titleStyles}>{title}</h2>}
      {children}
    </div>
  );
};
